/**
 * userpreferencesaction.js
 * Created by calhosh on 8/28/2020.
 */
import * as types from '../actiontypes';
import {GetByIdInternalUserUrl} from '../apiUrls';

export function getUserPreferences(url, resource) {
	return {
		type: types.GET_USER_PREFERENCES,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		}
	};
}

/**
 * Returns an action to be dispatched and treated by the api-middleware, ultimately making an API call through Axios.
 * Represents a request for an Internal User in the specified Engagement.
 * @param {Number} engagementId The Engagement ID.
 * @param {String} userId The User ID.
 * @param {Boolean} expandIndependenceInformation A value that determines whether to retrieve User Independence information or not.
 * @returns {Object} An action object to be dispatched and treated by the api-middleware.
 */
export function getInternalUserById(engagementId, userId, expandIndependenceInformation) {
	let expand;

	if (expandIndependenceInformation) {
		expand = 'independence';
	}

	const url = GetByIdInternalUserUrl(engagementId, userId, {expand});

	return {
		type: types.GET_INTERNAL_USER_BY_ID,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
}
